"use client";

import { useTranslations } from "next-intl";
import {
  getPriceCollectionCurrencySymbol,
  normalizeCurrencyCode,
} from "@/features/products/shared/priceCollections";
import { useCountryStore } from "@/lib/client/stores/useCountryStore";
import { Container } from "@/ui";

export interface ProductGridPriceFilter {
  maxPrice: number;
  supportedCurrencyCodes: readonly string[];
}

interface ProductGridHeaderProps {
  title: string;
  description?: string;
  priceFilter?: ProductGridPriceFilter;
}

export function ProductGridHeader({ title, description, priceFilter }: ProductGridHeaderProps) {
  const collectionT = useTranslations("collection_landing");
  const { country } = useCountryStore();
  const currencyCode = normalizeCurrencyCode(country.currencyCode);
  const usesSelectedCurrency =
    priceFilter?.supportedCurrencyCodes.some(
      (supportedCurrencyCode) => normalizeCurrencyCode(supportedCurrencyCode) === currencyCode,
    ) ?? false;
  const priceVars = {
    amount: priceFilter?.maxPrice ?? 80,
    symbol: getPriceCollectionCurrencySymbol(currencyCode),
  };
  const heading =
    priceFilter && usesSelectedCurrency
      ? collectionT("jewellery_under_price.title", priceVars)
      : title;
  const intro =
    priceFilter && usesSelectedCurrency
      ? collectionT("jewellery_under_price.description", priceVars)
      : description;

  return (
    <Container>
      <h1 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl">{heading}</h1>
      {intro ? (
        <p className="mb-6 max-w-3xl text-sm leading-6 text-muted-foreground sm:text-base">
          {intro}
        </p>
      ) : null}
    </Container>
  );
}
